import React, { Component } from 'react';
import { NavBar, Icon } from 'antd-mobile';
import Citychange from './city';
import { createBrowserHistory } from "history";
import './config';
import "../../utils/tool.jsx";

//首页导航
if(!window.globalvariable.getStore('cityid'))
{
    window.globalvariable.setStore('cityid', global.constants.cityid);
}
export class HomeHead extends Component {
    constructor(props) {
        super(props);
        this.state = {
            city: window.globalvariable.getStore('cityid'),
        }
     
    }
    getChildInfo = (name) => {
        this.setState({ city: name.children, value: name.value });
        window.globalvariable.setStore('cityid', name.value);
    }
    render() {
        return (
            <div>
                <div style={{ display: "block", width: "100%", position: "fixed", top: "0px", zIndex: "999" }}>
                    {<NavBar
                        mode="light"
                        rightContent={<Citychange toParent={this.getChildInfo.bind(this)} />
                        }
                    ></NavBar>}

                </div>
                <div style={{ display: "block", width: "100%", height: "45px", font: '.3rem' }}></div>
            </div>
        )
    }
}
//一般导航
export class CommonlyHead extends Component {
    render() {
        const history = createBrowserHistory();
        const tabUrl = require('../../res/images/bar_home_on.png');
        return (
            <div>
                <div style={{ display: "block", width: "100%", position: "fixed", top: "0px", zIndex: "999" }}>
                    <NavBar
                        mode="light"
                        icon={<Icon type="left" style={{ width: '30px', height: '30px'  }} />}
                        onLeftClick={() => history.goBack()}
                        rightContent={[
                            <img src={tabUrl} alt="" key="1" style={{ width: '25px', height: '25px' }} onClick={()=>
                            {
                                history.push('/');
                                history.go();
                            }} />
                        ]}

                    >{this.props.barname}</NavBar>

                </div>
                <div style={{ display: "block", width: "100%", height: "45px" }}>

                </div>
            </div>
        )
    }
}
//个人中心导航
export class CommonlyHeadMembers extends Component {
    render() {
        const history = createBrowserHistory();
        const tabUrl = require('../../res/images/bar_members_on.png');
        return (
            <div>
                <div style={{ display: "block", width: "100%", position: "fixed", top: "0px", zIndex: "999" }}>
                    <NavBar
                        mode="light"
                        icon={<Icon type="left" style={{ width: '30px', height: '30px'  }} />}
                        onLeftClick={() => history.goBack()}
                        rightContent={[
                            <img src={tabUrl} alt="" key="1" style={{ width: '25px', height: '25px' }} onClick={()=>
                            {
                                history.push('/members');
                                history.go();
                            }} />
                        ]}

                    >{this.props.barname}</NavBar>

                </div>
                <div style={{ display: "block", width: "100%", height: "45px" }}>

                </div>
            </div>
        )
    }
}